import pick from 'lodash/pick';
export const pickModelFields = (model, useVersionIntro) => {
  let extraData = {};

  if (useVersionIntro && model.versionIntro) {
    try {
      extraData = JSON.parse(model.versionIntro);
      if (Array.isArray(extraData.triggerWord)) {
        extraData.triggerWord = extraData.triggerWord.join(',');
      }
    } catch {
      // ...
    }
  }

  return pick(Object.assign({}, model, extraData), [
    'name',
    'versionId',
    'modelId',
    'versionName',
    'isHiddenStrategy',
    'uuid',
    'tagV2Ids',
    'baseType',
    'modelType',
    'runCount',
    'userAvatar',
    'userName',
    'imageUrl',
    'vipUsed',
    'weight',
    'modelUuid',
    'triggerWord',
    'from',
  ]);
};
